import { createApiService } from "../../../core/api/apiService";
import type { AppointmentRulesDto, UpdateAppointmentRulesDto } from "../types/appointmentRuleTypes";
import type {
  BusinessDto,
  CreateBusinessDto,
  UpdateBusinessDto,
  ReminderSettings,
  UpdateReminderSettingsDto,
} from "../types/businessTypes";

export function createBusinessApiService() {
  const api = createApiService("businesses");

  return {
    getAll: async (): Promise<BusinessDto[]> => {
      return api.get<BusinessDto[]>("");
    },

    getById: async (id: string): Promise<BusinessDto> => {
      return api.get<BusinessDto>(`/${id}`);
    },

    create: async (data: CreateBusinessDto): Promise<BusinessDto> => {
      return api.post<BusinessDto>("", data);
    },

    update: async (id: string, data: UpdateBusinessDto): Promise<BusinessDto> => {
      return api.put<BusinessDto>(`/${id}`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },

    getReminderSettings: async (id: string, signal?: AbortSignal): Promise<ReminderSettings> => {
      return api.get<ReminderSettings>(`/${id}/reminder-settings`, { signal });
    },

    getAppointmentRules: async (id: string, signal?: AbortSignal): Promise<AppointmentRulesDto> => {
      return api.get<AppointmentRulesDto>(`/${id}/appointment-rules`, { signal });
    },

    updateAppointmentRules: async (id: string, dto: UpdateAppointmentRulesDto): Promise<AppointmentRulesDto> => {
      return api.put<AppointmentRulesDto>(`/${id}/appointment-rules`, dto);
    },

    updateReminderSettings: async (id: string, data: UpdateReminderSettingsDto): Promise<ReminderSettings> => {
      return api.put<ReminderSettings>(`/${id}/reminder-settings`, data);
    },
  };
}

const businessApiService = createBusinessApiService();
export { businessApiService };
